import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import bank4 from "./Assets/bank4.png.jpeg";
import bank5 from "./Assets/bank5.png.jpeg";
import hotel2 from "./Assets/hotel2.png.jpeg";


export default function AdminDashLandingPage() {
  const images = [hotel2, bank5, bank4];
  const styles=`
@media(max-width:400px){
 .carousel-image{
  max-height: calc(100vh-50px);
 }
}

@media(max-width:600px){
 .carousel-image{
  max-height: calc(100vh-60px);
 }
}
 @media(max-width:900px){
 .carousel-image{
  max-height: calc(100vh-70px);
 }
}

@media(max-width:1200px){
 .carousel-image{
  max-height: calc(100vh-80px);
 }
}

`
const styleSheet=document.createElement("style")
styleSheet.type="text/css"
styleSheet.innerText=styles;
document.head.appendChild(styleSheet)
 

  return (
    <div className="flex flex-col h-full w-full overflow-hidden carousel-image">
      <Carousel
        showThumbs={false}
        autoPlay
        infiniteLoop
        className="flex-grow max-h-full"
      >
        {images.map((imageDir, index) => (
          <div key={index} className="flex justify-center items-center w-full h-full overflow-hidden">
            <img
              src={imageDir}
              alt={`Slide ${index}`}
              className="object-cover w-full h-full max-h-[calc(100vh-80px)]"
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
}



